import React, { useEffect, useState } from "react";
import { Col, Form, Modal, Row } from "react-bootstrap";
import SbCancelBtn, { SBSaveUpdateBtn } from "../../Buttons/Buttons";
import Select from 'react-select';
import { ADDED_BY_ID } from "../../../Constants";
import { useDispatch } from "react-redux";
import * as HeaderAuthentication from '../../HeaderAuthentication'
import { postStockConditionDatas } from "../../../redux/action";

const statusOptions = [
    { value: 95, label: "Active" },
    { value: 96, label: "Inactive" }
]

const AddStockCondition = (props) => {

    const stockConditionDatas = props.stockConditionDatas;
    const stockConditionID = props.stockConditionID;
    const singleStockConditionData = props.singleStockConditionData;

    const signInDetails = JSON.parse(sessionStorage.getItem('SignInDetails'));
    const storedCompanyID = signInDetails ? signInDetails[0].CompanyID : null;

    let dispatch = useDispatch();

    const [stockCondition, setStockCondition] = useState({
        StockConditionType: "",
        PercentValue: null,
        Description: "",
        StatusID: null,
        CompanyID: storedCompanyID,
        AddedByID: ADDED_BY_ID,
    })

    const [errors, setErrors] = useState({
        StockConditionType: "",
        PercentValue: null,
        Description: "",
    });

    useEffect(() => {
        if (stockConditionID && singleStockConditionData?.length > 0) {
            const stockConditionData = singleStockConditionData[0];
            setStockCondition({
                StockConditionID: stockConditionID,
                StockConditionType: stockConditionData.StockConditionType || "",
                PercentValue: parseInt(stockConditionData.PercentValue) || 0, // Convert to integer
                Description: stockConditionData.StockConditionDescription || "",
                CompanyID: stockConditionData.CompanyID,
                AddedByID: ADDED_BY_ID,
                StatusID: stockConditionData.StatusID || null
            });
        }
    }, [stockConditionID, singleStockConditionData]);

    const handleInputChange = (e) => {
        const { name, value } = e.target;
        setStockCondition((prevData) => ({
            ...prevData,
            [name]: name === "PercentValue" ? parseInt(value) || 0 : value, // Convert to integer if PercentValue
        }));
        setErrors((prevErrors) => ({
            ...prevErrors,
            [name]: "" // Clear error on typing
        }));
    };

    const handleSelectChange = (selectedOption, field) => {
        setStockCondition((prevData) => ({
            ...prevData,
            [field]: selectedOption ? selectedOption.value : null
        }));
        setErrors((prevErrors) => ({
            ...prevErrors,
            [field]: "" // Clear error on selecting
        }));
    };

    const validateForm = () => {
        const newErrors = {};
        if (!stockCondition.StockConditionType) newErrors.StockConditionType = "required!";
        if (!stockCondition.PercentValue) newErrors.PercentValue = "required!";
        if (!stockCondition.Description) newErrors.Description = "required!";

        setErrors(newErrors);
        return Object.keys(newErrors).length === 0;
    };

    const AddStockConditionData = (e) => {
        e.preventDefault();
        if (validateForm()) {
            const requestOption = {
                method: "POST",
                mode: "cors",
                headers: HeaderAuthentication.postExcomatixAuth,
                body: JSON.stringify(stockCondition),
            };
            dispatch(postStockConditionDatas(requestOption, props.handleCloseModal, stockConditionID, stockConditionDatas));
            console.log(stockCondition, 'stockCondition');
        }
    };

    return (
        <>
            <Modal show={props.open} onHide={props.handleCloseModal} className='add-role-modal'>
                <Modal.Header closeButton>
                    <Modal.Title>{stockConditionID ? "Edit Stock Condition" : "Add Stock Condition"}</Modal.Title>
                </Modal.Header>
                <Modal.Body>
                    <Row className='customer-form-fields'>
                        <Col>
                            <Row>
                                <Col md={6}>
                                    <div>
                                        <label>Condition Type <span className="required-asterisk">*</span></label>
                                        <Form.Control
                                            type="text"
                                            name="StockConditionType"
                                            value={stockCondition.StockConditionType}
                                            onChange={handleInputChange}
                                        />
                                    </div>
                                    {errors.StockConditionType && <div className="text-danger">{errors.StockConditionType}</div>}
                                </Col>
                                <Col md={6}>
                                    <div>
                                        <label>Percent Value<span className="required-asterisk">*</span></label>
                                        <Form.Control
                                            type="text"
                                            name="PercentValue"
                                            value={stockCondition.PercentValue}
                                            onChange={handleInputChange}
                                        />
                                    </div>
                                    {errors.PercentValue && <div className="text-danger">{errors.PercentValue}</div>}
                                </Col>
                            </Row>
                            <Row>
                                <Col md={12}>
                                    <div>
                                        <label className="pb-1 pt-1"> Description <span className="required-asterisk">*</span></label>
                                        <Form.Control
                                            as='textarea'
                                            rows='2'
                                            name="Description"
                                            value={stockCondition.Description}
                                            onChange={handleInputChange}
                                        />
                                    </div>
                                    {errors.Description && <div className="text-danger">{errors.Description}</div>}
                                </Col>
                            </Row>
                            <Row>
                                {stockConditionID && <Col md={4}>
                                    <div>
                                        <label>Status <span className="required-asterisk">*</span></label>
                                        <Select
                                            className="react-select-container"
                                            classNamePrefix="react-select"
                                            options={statusOptions}
                                            value={statusOptions.find(option => option.value === stockCondition.StatusID) || null}
                                            onChange={(selected) => handleSelectChange(selected, "StatusID")}
                                            placeholder="Select"
                                            menuPosition="fixed"
                                            menuShouldScrollIntoView={false}  // Prevents auto-scrolling issues
                                        />
                                    </div>
                                </Col>}
                            </Row>
                        </Col>
                    </Row>
                </Modal.Body>
                <Modal.Footer>
                    <SbCancelBtn btnName="Cancel" onClickEffect={props.handleCloseModal} />
                    <SBSaveUpdateBtn btnName="Submit" onClickEffect={AddStockConditionData} />
                </Modal.Footer>
            </Modal>
        </>
    );
}

export default AddStockCondition;
